import { render, staticRenderFns } from "./ChooseLabelFormat.vue?vue&type=template&id=076808a2&scoped=true"
import script from "./ChooseLabelFormat.vue?vue&type=script&lang=js"
export * from "./ChooseLabelFormat.vue?vue&type=script&lang=js"
import style0 from "./ChooseLabelFormat.vue?vue&type=style&index=0&id=076808a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076808a2",
  null
  
)

export default component.exports